export default __webpack_public_path__ + "static/media/426.793fdb82.jpg";